export default __webpack_public_path__ + "static/media/InfoViolet.2d3bee85.svg";